<script lang="ts">
	import { toasts, type ToastTone } from '$lib/toast';
	import { fly } from 'svelte/transition';
	import { flip } from 'svelte/animate';
	import { cubicOut } from 'svelte/easing';

	function getToastClasses(tone: ToastTone) {
		if (tone === 'success') {
			return {
				outer: 'bg-(--correct-frame-outer)',
				highlight: 'bg-(--correct-frame-highlight)',
				shadow: 'bg-(--correct-frame-shadow)',
				fill: 'bg-(--correct-frame-fill)',
				text: 'text-(--correct-frame-text)',
				icon: 'mdi:check-circle'
			};
		}

		if (tone === 'warning') {
			return {
				outer: 'bg-(--present-frame-outer)',
				highlight: 'bg-(--present-frame-highlight)',
				shadow: 'bg-(--present-frame-shadow)',
				fill: 'bg-(--present-frame-fill)',
				text: 'text-(--present-frame-text)',
				icon: 'mdi:alert'
			};
		}

		if (tone === 'error') {
			return {
				outer: 'bg-(--absent-frame-outer)',
				highlight: 'bg-(--absent-frame-highlight)',
				shadow: 'bg-(--absent-frame-shadow)',
				fill: 'bg-(--absent-frame-fill)',
				text: 'text-(--absent-frame-text)',
				icon: 'mdi:close-circle'
			};
		}

		if (tone === 'neutral') {
			return {
				outer: 'bg-(--bottom-nav-frame-outer)',
				highlight: 'bg-(--bottom-nav-frame-highlight)',
				shadow: 'bg-(--bottom-nav-frame-shadow)',
				fill: 'bg-(--bottom-nav-frame-fill)',
				text: 'text-(--bottom-nav-frame-text)',
				icon: 'mdi:information'
			};
		}

		return {
			outer: 'bg-(--guess-frame-outer)',
			highlight: 'bg-(--guess-frame-highlight)',
			shadow: 'bg-(--guess-frame-shadow)',
			fill: 'bg-(--guess-frame-fill)',
			text: 'text-(--guess-frame-text)',
			icon: 'mdi:information'
		};
	}
</script>

<div class="pointer-events-none fixed top-16 right-4 left-4 z-[60] flex flex-col items-center gap-2">
	{#each $toasts as toast (toast.id)}
		{@const toastClasses = getToastClasses(toast.tone)}
		<div
			class="pointer-events-auto w-full max-w-sm [filter:drop-shadow(0_4px_6px_rgba(0,0,0,0.35))_drop-shadow(0_2px_2px_rgba(0,0,0,0.25))]"
			in:fly={{ y: -20, duration: 450, easing: cubicOut }}
			out:fly={{ y: -12, duration: 320, easing: cubicOut }}
			animate:flip={{ duration: 380, easing: cubicOut }}
		>
			<div class="toast pixel-frame relative overflow-hidden" data-tone={toast.tone}>
				<div class={`pixel-frame absolute inset-0 ${toastClasses.outer}`}></div>
				<div class={`pixel-frame absolute inset-0.5 ${toastClasses.highlight}`}></div>
				<div class={`pixel-frame absolute inset-1.5 ${toastClasses.shadow}`}></div>
				<div class={`pixel-frame absolute inset-2 ${toastClasses.fill}`}></div>
				<div class={`pixel-frame absolute inset-2.5 ${toastClasses.shadow}`}></div>
				<div class={`toast-stripe absolute top-0 bottom-0 left-0 w-1.5 ${toastClasses.highlight}`}></div>
				<div class={`relative flex items-center gap-4 px-5 py-4 ${toastClasses.text}`}>
					{#if toast.icon}
						<img src={toast.icon} alt="" class="size-8 shrink-0" />
					{/if}
					<p class="text-base font-bold uppercase">{toast.message}</p>
				</div>
			</div>
		</div>
	{/each}
</div>
